import type Highcharts from 'highcharts';
import type { FC } from 'react';

import { HighchartsWidget } from '../../HighchartsWidget';
import { NoWidgetData } from '../NoWidgetData';
import { WidgetLoading } from '../widget-loading';
import type {
  RiskBubbleCluster,
  RiskBubbleClusterModalProps,
} from './parts/RiskBubbleClusterModal';
import { RiskBubbleClusterModal } from './parts/RiskBubbleClusterModal';

export interface RiskBubbleChartViewProps {
  loading: boolean;
  hasPoints: boolean;
  options: Highcharts.Options;
  emptyState: { title: string; body: string };
  /** The cluster the reader has opened, if any. */
  cluster: RiskBubbleCluster | null;
  clusterCopy: RiskBubbleClusterModalProps['copy'];
  onOpenRisk: (id: string) => void;
  onDismissCluster: () => void;
}

export const RiskBubbleChartView: FC<RiskBubbleChartViewProps> = ({
  loading,
  hasPoints,
  options,
  emptyState,
  cluster,
  clusterCopy,
  onOpenRisk,
  onDismissCluster,
}) => {
  if (loading) {
    return <WidgetLoading />;
  }

  if (!hasPoints) {
    return <NoWidgetData title={emptyState.title} body={emptyState.body} />;
  }

  return (
    <>
      {cluster && (
        <RiskBubbleClusterModal
          cluster={cluster}
          copy={clusterCopy}
          onOpenRisk={onOpenRisk}
          onDismiss={onDismissCluster}
        />
      )}
      <HighchartsWidget options={options} />
    </>
  );
};
